'use client'
import * as React from 'react'

type ClientDebuggerContextValue = {
  isDebugging: boolean
}

const ClientDebuggerContext = React.createContext<ClientDebuggerContextValue>({
  isDebugging: false,
})

export const ClientDebuggerProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [isDebugging, setIsDebugging] = React.useState(false)

  React.useEffect(() => {
    const url = new URL(window.location.href)
    const isDebugging = url.searchParams.get('debug') === 'true'
    setIsDebugging(isDebugging)
  }, [])

  return (
    <ClientDebuggerContext.Provider value={{ isDebugging }}>
      {children}
    </ClientDebuggerContext.Provider>
  )
}

export const useClientDebugger = () => {
  const context = React.useContext(ClientDebuggerContext)
  if (!context) {
    throw new Error(
      'useClientDebugger must be used within a ClientDebuggerProvider'
    )
  }
  return context
}
